export default __webpack_public_path__ + "static/image-53-f1555d45d9f4aa5900aa034848334ae1.jpg";